var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.9C9.27668 3.9 8.58299 4.17393 8.07153 4.66152C7.56006 5.14912 7.27273 5.81044 7.27273 6.5C7.27273 7.18956 7.56006 7.85088 8.07153 8.33848C8.58299 8.82607 9.27668 9.1 10 9.1C10.7233 9.1 11.417 8.82607 11.9285 8.33848C12.4399 7.85088 12.7273 7.18956 12.7273 6.5C12.7273 5.81044 12.4399 5.14912 11.9285 4.66152C11.417 4.17393 10.7233 3.9 10 3.9ZM10 10.8333C8.79447 10.8333 7.63832 10.3768 6.78588 9.56413C5.93344 8.75147 5.45455 7.64927 5.45455 6.5C5.45455 5.35073 5.93344 4.24853 6.78588 3.43587C7.63832 2.62321 8.79447 2.16667 10 2.16667C11.2055 2.16667 12.3617 2.62321 13.2141 3.43587C14.0666 4.24853 14.5455 5.35073 14.5455 6.5C14.5455 7.64927 14.0666 8.75147 13.2141 9.56413C12.3617 10.3768 11.2055 10.8333 10 10.8333ZM10 0C5.45455 0 1.57273 2.69533 0 6.5C1.57273 10.3047 5.45455 13 10 13C14.5455 13 18.4273 10.3047 20 6.5C18.4273 2.69533 14.5455 0 10 0Z",
    fill: "#4B2D10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6d74b05e75633913ea3bc76a9744340b.svg";
export { ForwardRef as ReactComponent };